import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_email_by_id = (id) => {
  return api.post(`${ApiEndpointConstants.SHOWEMAIL}`, {}, { params: { id } });
};
